import { api } from "./api";

/**
 * Lo que la modelo consulta sobre sí misma.
 *
 * Va por `/me` y no por `/model/{id}`: su panel no conoce el id de su propio
 * perfil, y averiguarlo exigiría el listado de modelos, que es una pantalla de
 * administración a la que no tiene acceso.
 */

export const fetchMyModelService = () => api.get('/me/model');

export const fetchMySupportersService = (params = {}) => api.get('/me/supporters', { params });
